import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import socioService from "../services/socioService";
import "../styles/socioPublico.css";

function SocioPublico() {
  const { id } = useParams();
  const [socio, setSocio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const fetchSocio = async () => {
      try {
        setLoading(true);
        const data = await socioService.obtenerSocioPublicoPorId(id);
        if (active) {
          setSocio(data);
          setError("");
        }
      } catch (err) {
        if (active) {
          setError(err.message || "No se pudo cargar el socio.");
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchSocio();
    return () => {
      active = false;
    };
  }, [id]);

  const fechaRegistro = useMemo(() => {
    if (!socio?.fecha_ins) return "N/A";
    return new Date(socio.fecha_ins).toLocaleDateString("es-BO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }, [socio?.fecha_ins]);

  return (
    <main className="socio-publico-page">
      <section className="socio-publico-card">
        <header className="socio-publico-header">
          <h1>Verificación de Socio</h1>
        </header>

        {loading && <p className="socio-publico-state">Cargando información...</p>}
        {!loading && error && <p className="socio-publico-state error">{error}</p>}

        {!loading && !error && socio && (
          <div className="socio-publico-body">
            <div className="socio-publico-info">
              <p>
                <strong>Nombre completo:</strong> {socio.nombre_completo || "N/A"}
              </p>
              <p>
                <strong>RNI:</strong> {socio.rni || "N/A"}
              </p>
              <p>
                <strong>CI:</strong> {socio.ci || "N/A"}
              </p>
              <p>
                <strong>Reg ABIS:</strong> {socio.reg_abis || "N/A"}
              </p>
              <p>
                <strong>Fecha de registro:</strong> {fechaRegistro}
              </p>
              <p>
                <strong>Universidad:</strong> {socio.universidad || "N/A"}
              </p>
            </div>

            {socio.avatar_url && (
              <div className="socio-publico-photo">
                <img src={socio.avatar_url} alt={socio.nombre_completo || "Socio"} />
              </div>
            )}
          </div>
        )}

        <p className="socio-publico-disclaimer">
          <strong>IMPORTANTE</strong>: La Información contenida en la presente Guía Electrónica no
          constituye una certificación profesional ni acredita legalmente a los profesionales
          Ingenieros Registrados ante terceras personas, Instituciones o Empresas Privadas. Las
          Certificaciones Oficiales deberán ser solicitadas en oficinas de la SIB Nacional o en las
          Oficinas Departamentales.
        </p>
      </section>
    </main>
  );
}

export default SocioPublico;
